/* eslint-disable @next/next/no-img-element */
import { LanguageText } from "./LanguageText";

export function FooterAffiliation() {
  return (
    <div className="footer-institution-strip">
      <a
        className="footer-institution-mark"
        href="https://www.syau.edu.cn/"
        target="_blank"
        rel="noreferrer"
        aria-label="沈阳农业大学官方网站 / Official website of Shenyang Agricultural University"
      >
        <img
          src="/institutions/shenyang-agricultural-university-emblem.png"
          alt="沈阳农业大学校徽 / Shenyang Agricultural University emblem"
          width={612}
          height={475}
        />
      </a>
      <div className="footer-institution-copy">
        <LanguageText
          as="strong"
          zh="项目所属机构：沈阳农业大学"
          en="Project institution: Shenyang Agricultural University"
        />
        <LanguageText
          as="p"
          zh="TrypCell Atlas 由沈阳农业大学分子寄生虫课题组建设。"
          en="TrypCell Atlas is developed by the Molecular Parasitology Research Group at Shenyang Agricultural University."
        />
        <LanguageText
          as="small"
          zh="校徽用于说明项目团队的机构归属，不表示学校对每条数据记录或每个网站版本作单独官方认证。"
          en="The emblem identifies the project team's institutional affiliation; it does not constitute separate university certification of every data record or portal release."
        />
      </div>
      <div className="footer-institution-links">
        <a href="https://www.syau.edu.cn/" target="_blank" rel="noreferrer">
          <LanguageText zh="学校官网 ↗" en="University website ↗" />
        </a>
        <a
          href="https://www.syau.edu.cn/syauold/xxgk/snbs.htm"
          target="_blank"
          rel="noreferrer"
        >
          <LanguageText
            zh="官方标识来源 ↗"
            en="Official identity source ↗"
          />
        </a>
      </div>
    </div>
  );
}
